import { Star } from "lucide-react";

export function StarRating({ rating, size = "md", showValue = true }) {
  const sizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
    xl: "w-6 h-6",
  };

  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className="flex items-center gap-1.5">
      <div className="flex items-center gap-0.5">
        {[...Array(fullStars)].map((_, i) => (
          <Star key={`full-${i}`} className={`${sizes[size]} star-filled fill-current`} />
        ))}
        {hasHalfStar && (
          <div className="relative">
            <Star className={`${sizes[size]} star-empty`} />
            <div className="absolute inset-0 overflow-hidden w-1/2">
              <Star className={`${sizes[size]} star-filled fill-current`} />
            </div>
          </div>
        )}
        {[...Array(emptyStars)].map((_, i) => (
          <Star key={`empty-${i}`} className={`${sizes[size]} star-empty`} />
        ))}
      </div>
      {showValue && (
        <span className="text-white font-semibold text-sm ml-1">{rating.toFixed(1)}</span>
      )}
    </div>
  );
}

export function RatingBar({ value, max = 5, label, color = "primary" }) {
  const percentage = (value / max) * 100;
  
  const colors = {
    primary: "from-primary to-purple-500",
    gold: "from-secondary to-amber-500",
    blue: "from-accent to-blue-400",
  };

  return (
    <div className="flex items-center gap-3">
      {label && <span className="text-white/60 text-sm w-24">{label}</span>}
      <div className="flex-1 h-2 bg-white/10 rounded-full overflow-hidden">
        <div 
          className={`h-full bg-gradient-to-r ${colors[color]} rounded-full transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className="text-white font-medium text-sm w-10 text-right">{value.toFixed(1)}</span>
    </div>
  );
}
